import { PcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { DatePickerType } from '@/constants/datePicker';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type Args = {
  bizType?: BizType;
  targetId: string;
  calendarType: DatePickerType.WEEKLY | DatePickerType.MONTHLY | DatePickerType.YEARLY;
  startDate: string;
  endDate: string;
};

export type Count = {
  date: string;
  count: number;
};

export type RequestedCount = {
  currentCount: number;
  currentRate?: number;
  changeRate?: number;
  dailyCounts: Count[];
};

export const getRequestedCount = (args: Args) => {
  if (!args.bizType) return Promise.resolve(null);
  return api<PcApiResponse<RequestedCount>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/statistics/organizations/requested/count`,
    args
  );
};
